import { Tabs } from "../../components";
import { ROUTES } from "../../shell";

const ONGLETS = [
  { to: ROUTES.parametresEquipe, label: "Équipe" },
  { to: ROUTES.parametresMarque, label: "Marque" },
  { to: ROUTES.parametresPaiement, label: "Paiement" },
];

/** Les onglets des paramètres de l'entreprise. */
export function ParametresOnglets() {
  return <Tabs items={ONGLETS} label="Sections des paramètres" />;
}
